export const HOUR_TO_SECONDS = 3600;
export const HOUR_TO_MILLISECONDS = 3600 * 1000;
export const SECOND_TO_MILLISECONDS = 1000;
export const MINUTE_TO_MILLISECONDS = 60000;
export const DAY_TO_MILLISECONDS = 24 * 3600 * 1000;
